export default {
  LOAD_STUDY_PLAN_CYCLE_THEORETICAL_PART_LIST_START: 'LoadStudyPlanCycleTheoreticalPartListStart',
  LOAD_STUDY_PLAN_CYCLE_THEORETICAL_PART_LIST_END: 'LoadStudyPlanCycleTheoreticalPartListEnd',
  TOGGLE_STUDY_PLAN_CYCLE_THEORETICAL_PART_CONFIRM_DIALOG: 'ToggleStudyPlanCycleTheoreticalPartConfirmDialog'
};